// extracted by mini-css-extract-plugin
export default {"root":"CustomSelect_root__v7APO","withoutBorder":"CustomSelect_withoutBorder__De7nl","labelInsideBorder":"CustomSelect_labelInsideBorder__JLDrZ"};